// Assimetria e simetria entre lados. As duas são complementares: somam 100.

const { toNumber, round } = require('./primitives');

// Quanto os lados diferem, em % do maior valor.
function asymmetry(a, b) {
    const right = toNumber(a);
    const left = toNumber(b);
    if (right === null || left === null) return null;

    const highest = Math.max(right, left);
    if (highest === 0) return 0;

    return round((Math.abs(right - left) / highest) * 100);
}

// Quanto os lados se parecem. `symmetry + asymmetry === 100`.
function symmetry(a, b) {
    const right = toNumber(a);
    const left = toNumber(b);
    if (right === null || left === null) return null;

    const highest = Math.max(right, left);
    if (highest === 0) return null;

    return round((Math.min(right, left) / highest) * 100);
}

module.exports = {
    asymmetry,
    symmetry
};
